module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "BM-Head-bmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-No-Indent-Space-After-bmtx1-"
  }, [_vm._v("Thank you to:")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("Sarah Bowlin, my talented and generous editor, who made this book so much better.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("Elisabeth Weed, my agent, friend, and advocate from the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("All the folks at Henry Holt. Every writer should have a team this good.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("My first readers: Alex Darrow, Susannah Meadows, Jessica Darrow, and Michelle Wildgen, whose kindness and guidance nudged me forward from a first draft.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("Christina Paige. Boise City, baby!")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("Jennifer Sey, Mark Sundeen, April Saks, Carolyn Frazier, Andrew Wilcox, Lance McDaniel, Amy Sweigert, Carol Lawson, Lynn Kilpatrick, Darin Strauss, Lewis Buzbee, Sabine Laerum, Emma Fusco-Straub, Curtis Sittenfeld, Emily Bell, Michael Donohue, Dune Lawrence, David Khoury, Maartje Oldenburg, Melissa Kantor, Ben Gantcher, Rebekah Coleman, Meredith and Jennifer Bell, Aaron Sanders, and Denise Wood Hahn.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("The Twin Cities contingent: Pamela Klinger-Horn, Beth Slater Winnick, Nina Roberson, Frank Bures, Bridgit Jordan, Jeff Chen, and Karen Ho.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("My friends from the University of Utah Creative Writing Program.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("Bob Barry and the Wednesday crew at the LIU pottery studio.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("The Meadows and Darrow families, always.")]), _vm._v(" "), _c('p', {
    staticClass: "BM-Text-Space-After-bmtx-"
  }, [_vm._v("Alex, Indigo, and Olive. You are the best.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0